import { atom } from "jotai"
import { EdgeDirection } from "@features/builder/CreateEdges/types"

export type CreateEdgesDialogAtom = {
  open: boolean
  sourceNodeIds: string[]
  initialDirection: EdgeDirection
}

export const createEdgesDialogAtom = atom<CreateEdgesDialogAtom>({
  open: false,
  sourceNodeIds: [],
  initialDirection: "Parents",
})

if (process.env.NODE_ENV !== "production") {
  createEdgesDialogAtom.debugLabel = "createEdgesDialogAtom"
}
